import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";

import { DatasetState } from "@/store/datasets/types";

import buildUrl from "build-url";

import { eventLoading } from "@/components/sce/EventLoading"; // This class controls loading state to update progress bar

@Component({
    components: {},
})
export default class EndpointData extends Vue {
    @State("datasets") datasets!: DatasetState;

    init: boolean = false;
    loading: boolean = false;
    data: any = [];

    get dataset(): any {
        return this.datasets.dataset;
    }

    getQueryParams(): any {
        // Override this to provide a specific set of query params for a tool.
        throw new Error("getQueryParams is not implemented!!");
    }

    loadData(url: string, params?: any) {
        // Load the data from an endpoint using the query params
        // defined by a concrete implementation of a tool.

        this.loading = true;
        eventLoading.startLoading();

        // Get the query params from the overwridden method.
        var p = this.getQueryParams();

        // Add in any additional params.
        if (params) {
            p = Object.assign({}, p, params);
        }

        // Fetch the data from the endpoint.
        Vue.axios({
            url: buildUrl(url, { queryParams: p }),
        })
            .then((response: any) => {
                this.data = response.data;
                this.init = true;
            })
            .catch((error: any) => {
                console.error(error);
                this.init = false;
            })
            .finally(() => {
                this.loading = false;
                eventLoading.stopLoading();
            });
    }
}
